import { useEffect, useState } from "react";

/** Epoch ms, refreshed every 30s while mounted (wait times, availability). */
export function useMinuteNow(intervalMs = 30 * 1000): number {
  const [now, setNow] = useState(() => Date.now());
  useEffect(() => {
    setNow(Date.now());
    const id = window.setInterval(() => setNow(Date.now()), intervalMs);
    return () => window.clearInterval(id);
  }, [intervalMs]);
  return now;
}
